<!--
일괄기능 — 구매요청 「구매정보저장」 (TASK-161 §0-13 · §0-14 · E3 — 사이클 12 결정 39-⑪ · 39-⑫)
------------------------------------
 - 열기 = 선택 상품 → 미리보기 GET /admin/buy-requests/store-order-preview (읽기 전용 — 서버가 저장 대상 확장 · 편입 판정)
     · 저장 대상 = 선택 상품 + 같은 3키 · 같은 해외오더번호의 구매요청 대기 상품 전부 (「같은 해외오더번호 상품 N건이 함께 저장됩니다」)
     · 상품 카드 (사이클 13 #4 — 공용 app-buy-order-prod-cards: 이미지 · 상품번호 + 쇼핑몰 / 브랜드 · 상품명 / 색상 · 사이즈 · 수량 × 구입단가
       · 수취인 · 배송코드 · 트래킹 · 배송단계 · 우상단 칩 「직접 선택」 / 「같은 오더번호 자동 포함」)
     · 사이클 16 #27: 상품 = 간략 행 (썸네일 · 상품번호 · 브랜드·상품명 · 옵션 · 수량×단가 · 단계 · 칩 「자동 포함」 — 수취인 · 배송코드 · 트래킹 · 쇼핑몰 행에서 제거)
     · TASK-176: 「직접 선택」 칩 제거 (자동 포함 행에만 칩) · 요약 줄 = 「저장 대상 상품 N건 (같은 해외오더번호로 자동 포함 M건)」 (M = 0 이면 괄호 없음)
 - 오더번호 (39-⑫) = 선택 상품 코드가 하나로 통일 → 텍스트 (읽기 전용, 「오더번호는 상품 행에서 수정」) / 전부 빈 값 → input (입력 후 미리보기 재조회)
     · 사이클 16 #27: 텍스트 모드 = 공용 컨텍스트 헤더 app-buy-order-ctx (오더번호 크게 + 복사 · 트래킹 칩 = 저장 대상 상품 트래킹) / input · 불일치 모드 = 현행
     · 사이클 14 #11: 재조회 버튼 = 「다른상품 조회」 (input 과 한 줄 · 고정 폭) + 보조 설명 1줄 · Enter = 같은 동작
     · 서로 다르면 안내 + 저장 차단 (서버 MSG_CODE_MISMATCH 와 같은 규칙)
 - 입력 오더번호의 구매정보 없음 = 생성: 실제결제금액 기본값 = 대상 전체 구입단가 × 수량 합계 · 대금상환 체크 (기본 OFF — 결정 3)
   있음 = 편입: 「기존 구매정보에 편입됩니다」 + 실제결제금액 읽기전용 (기존 값 유지) · 대금상환 체크 없음
 - 저장 = POST /admin/buy-requests/store-order (prod_ids = 선택 상품 — 확장은 서버가 같은 규칙으로 다시 계산)
 - TASK-176 요구사항 변경 2 (추가 3: 라디오 → 버튼 묶음 uk-button-group, 선택 = 파랑): 소속상품 단계 변경 3안 (생성·편입 공통) → state_change = buy_done ((고넬로)구매완료, 기본 선택) | buying (구매진행중) | none (단계변경안함)
     — 선택 단계로 소속 상품 전부 변경 시도 (이미 같은 단계 = 건너뜀 · 이후 단계 상품도 선택 단계로 바뀜 ·
     잠금 등으로 변경이 거부되는 상품이 있으면 저장 전체 실패 → 「단계변경안함」 으로 재저장)
 - 차단 문구 = 서버 메세지 그대로 alert · 성공 후 페이지 새로고침
-->
<template>
    <div uk-modal esc-close="false" bg-close="false" class="br-store-order-modal">
        <div class="uk-modal-dialog uk-modal-body uk-width-xxlarge">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <h3 class="uk-modal-title">구매정보저장</h3>

            <!-- 해외오더번호 (39-⑫) — 텍스트 모드 = 공용 컨텍스트 헤더 (사이클 16 #27: 오더번호 크게 + 복사 · 트래킹 칩 = 저장 대상 상품의 트래킹) -->
            <app-buy-order-ctx v-if="codeMode === 'text'" class="br-store-code" code-class="br-store-code-text"
                               :code="fixedCode" :trackings="previewTrackings">
                <template v-slot:note>
                    <span class="uk-text-muted br-store-code-hint">오더번호는 상품 행에서 수정</span>
                </template>
            </app-buy-order-ctx>
            <div v-else class="uk-margin br-store-code">
                <label class="uk-form-label">해외오더번호</label>
                <template v-if="codeMode === 'input'">
                    <!-- 사이클 14 #11 — input 과 버튼 한 줄 (버튼 고정 폭 · 줄바꿈 금지) + 보조 설명 1줄 · Enter = 같은 동작 -->
                    <div class="uk-form-controls br-store-code-row">
                        <input class="uk-input br-store-code-input" type="text" v-model.trim="inputBuyOrderCode"
                               placeholder="해외오더번호를 입력하세요" @change="reloadPreview" @keyup.enter="reloadPreview"/>
                        <button class="uk-button uk-button-default br-store-code-btn" type="button" :disabled="loading || inputBuyOrderCode === ''"
                                @click="reloadPreview">다른상품 조회</button>
                    </div>
                    <div class="uk-text-muted br-store-code-help">
                        오더번호를 입력하고 「다른상품 조회」 를 누르면 같은 번호의 대기 상품이 함께 저장 대상에 들어갑니다
                    </div>
                </template>
                <div v-else class="uk-text-danger br-store-code-mismatch">
                    선택 상품의 해외오더번호가 서로 다릅니다 ({{ distinctCodes.join(', ') }}).
                    동일한 해외오더번호로 수정 후 저장해 주세요.
                </div>
            </div>

            <!-- 저장 대상 -->
            <div class="uk-margin">
                <div v-if="loading" class="uk-text-muted br-store-loading">
                    <div uk-spinner></div> 저장 대상 확인 중…
                </div>
                <template v-else-if="preview">
                    <p class="uk-text-primary br-store-summary">
                        저장 대상 상품 {{ preview.prods.length }}건<span v-if="autoCount > 0"> (같은 해외오더번호로 자동 포함 {{ autoCount }}건)</span>
                    </p>
                    <div v-if="! isAttach && previewCode !== ''" class="br-store-together">
                        같은 해외오더번호 상품 {{ preview.prods.length }}건이 함께 저장됩니다
                    </div>
                    <div v-if="isAttach" class="br-store-attach-note">
                        기존 구매정보에 편입됩니다 — 실제결제금액 · 대금상환은 기존 구매정보 그대로입니다 (변경은 완료 카드 「수정」)
                    </div>

                    <!-- 상품 목록 (사이클 13 #4 카드 → 16 #27 간략 행, 공용 app-buy-order-prod-cards — 스크롤 = 목록 안) -->
                    <div class="br-store-prods-wrap">
                        <app-buy-order-prod-cards :prods="preview.prods" card-class="br-store-prod-row"></app-buy-order-prod-cards>
                    </div>
                </template>
            </div>

            <!-- 실제결제금액 -->
            <div class="uk-margin" v-if="preview && ! loading">
                <label class="uk-form-label">
                    실제결제금액 <span v-if="priceCurrency">({{ priceCurrency }})</span>
                </label>
                <div v-if="isAttach" class="br-store-price-text">
                    {{ existingPriceText }} <span class="uk-text-muted">(기존 구매정보 — 읽기 전용)</span>
                </div>
                <template v-else>
                    <input class="uk-input br-store-price" type="text" v-model.trim="inputPaymentPrice" placeholder="실제결제금액"/>
                    <div class="uk-text-muted uk-margin-small-top">
                        기본값 = 저장 대상 전체 구입단가 × 수량 합계 {{ sumText }}
                    </div>
                    <div v-if="preview.currencies.length > 1" class="uk-text-danger uk-margin-small-top">
                        저장 대상 상품의 구입단가 통화가 서로 다릅니다 ({{ preview.currencies.join(', ') }}).
                    </div>
                </template>
            </div>

            <!-- TASK-176 요구사항 변경 2 — 소속상품 단계 변경 버튼 묶음 (생성·편입 공통, 기본 (고넬로)구매완료) -->
            <div class="uk-margin br-store-state-change" v-if="preview && ! loading">
                <label class="uk-form-label">소속상품 단계 변경</label>
                <div class="uk-form-controls">
                    <div class="uk-button-group br-store-state-group" role="group" aria-label="소속상품 단계 변경">
                        <button type="button" class="uk-button br-store-state-btn br-store-state-buy-done"
                                :class="stateBtnClass('buy_done')" :aria-pressed="inputStateChange === 'buy_done' ? 'true' : 'false'"
                                @click="inputStateChange = 'buy_done'">(고넬로)구매완료</button>
                        <button type="button" class="uk-button br-store-state-btn br-store-state-buying"
                                :class="stateBtnClass('buying')" :aria-pressed="inputStateChange === 'buying' ? 'true' : 'false'"
                                @click="inputStateChange = 'buying'">구매진행중</button>
                        <button type="button" class="uk-button br-store-state-btn br-store-state-none"
                                :class="stateBtnClass('none')" :aria-pressed="inputStateChange === 'none' ? 'true' : 'false'"
                                @click="inputStateChange = 'none'">단계변경안함</button>
                    </div>
                </div>
                <div class="uk-text-muted uk-text-small">
                    선택한 단계로 위 저장 대상 상품 전부의 단계를 바꿉니다 (이미 같은 단계인 상품은 그대로, 이후 단계의 상품도 선택한 단계로 바뀝니다).
                    단계를 바꿀 수 없는 상품이 하나라도 있으면 저장되지 않으니, 그때는 「단계변경안함」 으로 다시 저장해 주세요.
                </div>
            </div>

            <template v-if="preview && ! loading && ! isAttach">
                <div class="uk-margin">
                    <label>
                        <input class="uk-checkbox br-store-cod" type="checkbox" v-model="inputCodPayment"/>
                        대금상환
                    </label>
                </div>

                <div class="uk-margin" v-show="inputCodPayment">
                    <label class="uk-form-label">대금상환비고 (선택)</label>
                    <textarea class="uk-textarea" rows="3" v-model="inputReqMemo" placeholder="대금상환비고"></textarea>
                </div>
            </template>

            <div class="uk-text-right">
                <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                <button class="uk-button uk-button-primary br-store-submit" type="button" :disabled="! canSubmit" @click="submit">
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * 일괄기능 공유data (BuyRequestIndexTrait::buyRequestBatchJson)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // 작업대상 아이템 (jobInit 시점 선택 상품)
                targets: [],

                // 미리보기 (서버 응답) · 미리보기 기준 오더번호
                preview: null,
                previewCode: '',
                loading: false,

                inputBuyOrderCode: '',
                inputPaymentPrice: '',
                inputCodPayment: false,
                inputReqMemo: '',
                inputStateChange: 'buy_done', // TASK-176 — 소속상품 단계 변경 버튼 묶음 (buy_done | buying | none, 기본 (고넬로)구매완료)

                busy: false,
            };
        },
        computed: {
            // 선택 상품의 오더번호 (공란 제외, 중복 제거)
            distinctCodes() {
                return _.uniq(_.filter(_.map(this.targets, (item) => {
                    return (item.buy_order_code === null || item.buy_order_code === undefined) ? '' : String(item.buy_order_code).trim();
                }), (code) => code !== ''));
            },

            // 39-⑫ — text (코드 하나로 통일) / input (전부 빈 값) / mismatch (서로 다름)
            codeMode() {
                if (this.distinctCodes.length === 1) {
                    return 'text';
                }
                if (this.distinctCodes.length === 0) {
                    return 'input';
                }
                return 'mismatch';
            },

            fixedCode() {
                return this.distinctCodes.length === 1 ? this.distinctCodes[0] : '';
            },

            // 컨텍스트 헤더 트래킹 칩 = 저장 대상 상품의 트래킹번호 (중복 · 빈 값 제외 — 사이클 16 #27, 상품 행에서 트래킹 제거). 미리보기 전 = null (줄 숨김)
            previewTrackings() {
                if (! this.preview || this.loading) {
                    return null;
                }
                return _.uniq(_.filter(_.map(this.preview.prods, (p) => {
                    return (p.tracking_no === null || p.tracking_no === undefined) ? '' : String(p.tracking_no).trim();
                }), (no) => no !== ''));
            },

            // 저장할 오더번호
            submitCode() {
                return this.codeMode === 'text' ? this.fixedCode : this.inputBuyOrderCode;
            },

            isAttach() {
                return !! (this.preview && this.preview.existing_order);
            },

            selectedCount() {
                return this.preview ? _.filter(this.preview.prods, 'selected').length : 0;
            },

            autoCount() {
                return this.preview ? this.preview.prods.length - this.selectedCount : 0;
            },

            priceCurrency() {
                if (this.isAttach) {
                    return this.preview.existing_order.currency || '';
                }
                return (this.preview && this.preview.currencies.length === 1) ? this.preview.currencies[0] : '';
            },

            sumText() {
                if (! this.preview) {
                    return '';
                }
                return this.priceText(this.preview.sum, this.priceCurrency);
            },

            existingPriceText() {
                if (! this.isAttach) {
                    return '';
                }
                let price = this.preview.existing_order.payment_price;
                if (price === null || price === undefined || String(price).trim() === '') {
                    return '미입력';
                }
                return this.priceText(price, this.preview.existing_order.currency);
            },

            canSubmit() {
                if (this.busy || this.loading || ! this.preview || this.codeMode === 'mismatch') {
                    return false;
                }
                // 미리보기 기준 오더번호 = 저장 오더번호 (입력 후 「확인」 전에는 저장 불가 — 대상 · 편입 판정이 바뀔 수 있음)
                return this.submitCode !== '' && this.previewCode === this.submitCode;
            },
        },
        methods: {
            // 배송단계 변경 버튼 — 선택 = 파랑 (uk-button-primary), 나머지 = 기본
            stateBtnClass(value) {
                return this.inputStateChange === value ? 'uk-button-primary' : 'uk-button-default';
            },

            // 금액 표시 (JPY 소수점 없음)
            priceText(val, currency) {
                let num = parseFloat(val);
                if (isNaN(num)) {
                    return '—';
                }
                let digits = currency === 'JPY' ? 0 : 2;
                return (currency ? currency + ' ' : '') + this.$formatNumber(num, digits);
            },

            // 작업초기화 (버튼 클릭 → 모달 즉시 표시 → 미리보기 조회)
            jobInit() {
                this.targets = _.filter(this.batch.items, ['checked', true]);
                if (this.targets.length === 0) {
                    alert('선택된 상품이 없습니다.');
                    return;
                }

                this.preview = null;
                this.previewCode = '';
                this.inputBuyOrderCode = '';
                this.inputPaymentPrice = '';
                this.inputCodPayment = false; // 결정 3 — 체크 기본값 OFF
                this.inputReqMemo = '';
                this.inputStateChange = 'buy_done'; // TASK-176 — 기본 (고넬로)구매완료

                UIkit.modal(this.$el).show();

                if (this.codeMode === 'text') {
                    this.loadPreview(this.fixedCode);
                } else if (this.codeMode === 'input') {
                    // 오더번호 입력 전 = 선택 상품만 (확장 없음)
                    this.loadPreview('');
                }
            },

            // 입력 오더번호로 미리보기 재조회 (39-⑪ — 그 오더번호의 구매정보 있으면 편입 · 대기 상품 확장)
            reloadPreview() {
                if (this.codeMode !== 'input' || this.loading) {
                    return;
                }
                if (this.inputBuyOrderCode === this.previewCode && this.preview) {
                    return;
                }
                this.loadPreview(this.inputBuyOrderCode);
            },

            loadPreview(code) {
                this.loading = true;
                let data = {
                    prod_ids: _.map(this.targets, 'id'),
                };
                if (code !== '') {
                    data.buy_order_code = code;
                }
                $.app.ajax.module.default({
                    type: 'get',
                    url: '/admin/buy-requests/store-order-preview',
                    dataType: 'json',
                    data: data,
                    success: (response) => {
                        this.preview = response;
                        this.previewCode = code;
                        if (! response.existing_order) {
                            this.inputPaymentPrice = response.sum > 0 ? String(response.sum) : '';
                        }
                    },
                    complete: () => {
                        this.loading = false;
                    },
                });
            },

            submit() {
                if (! this.canSubmit) {
                    return;
                }
                let count = this.preview.prods.length;
                let msg = this.isAttach
                    ? '선택 상품 ' + count + '건을 기존 구매정보 (' + this.submitCode + ') 에 편입합니다. 정말 실행합니까?'
                    : count + ' 개 상품으로 구매정보를 저장합니다' + (this.autoCount > 0 ? ' (같은 해외오더번호로 자동 포함 ' + this.autoCount + '건)' : '') + '. 정말 실행합니까?';
                if (! confirm(msg)) {
                    return;
                }
                this.busy = true;

                $.app.ajax.module.default({
                    type: 'post',
                    url: '/admin/buy-requests/store-order',
                    dataType: 'json',
                    data: {
                        _token: this.csrfToken,
                        prod_ids: _.map(this.targets, 'id'),
                        buy_order_code: this.submitCode,
                        payment_price: this.isAttach ? '' : this.inputPaymentPrice,
                        cod_payment: (! this.isAttach && this.inputCodPayment) ? 'yes' : 'no',
                        req_memo: (! this.isAttach && this.inputCodPayment) ? this.inputReqMemo : '',
                        state_change: this.inputStateChange,
                    },
                    success: (response) => {
                        if (response && response.msg) {
                            alert(response.msg);
                        }
                        $.app.refresh();
                    },
                    complete: () => {
                        this.busy = false;
                    },
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    // 사이클 14 #11 — input (가변) + 「다른상품 조회」 (고정 폭, 「확 / 인」 2줄 깨짐 해소)
    .br-store-code-row {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 6px;

        .br-store-code-input {
            flex: 1 1 auto;
            min-width: 0;
        }

        .br-store-code-btn {
            flex: none;
            white-space: nowrap;
        }
    }

    .br-store-code-help {
        margin-top: 4px;
    }

    .br-store-together,
    .br-store-attach-note {
        margin: 6px 0;
        padding: 6px 10px;
        border-left: 4px solid #1e87f0;
        color: #2b5aa0;
    }

    // (구 .br-store-prods-wrap 높이 제한 50vh = 사이클 16 #27 공용 목록 안 스크롤로 이전 — 래퍼 마크업은 유지)

    // TASK-176 — 배송단계 변경 버튼 묶음 (한 줄 세그먼트, 선택 = uk-button-primary 파랑)
    .br-store-state-group {
        flex-wrap: nowrap;

        .br-store-state-btn {
            white-space: nowrap;
        }
    }

    .br-store-price-text {
        font-family: "IBM Plex Mono", ui-monospace, monospace;
    }
</style>
